import { useSelector } from 'react-redux';
import { isSourceAniAli } from '../components/Location/helpers';
import { getMostRecentLocations } from '../utils/getMostRecentLoc';

/**
 * Custom hook to determine whether or not to render the Text-From-911 Chat
 * for a given phone number. If a phone number is considered a landline call,
 * do not render TF911. A phone number is considered a landline if its secondary
 * location data contains an `ani_` value for the `application`
 * @param {String} callerID - phone number
 */
const useShouldRenderTF911 = callerID => {
  // Throw an error if callerID is not provided to make this required for usage
  if (!callerID) {
    throw new Error('callerID not provided to useShouldRenderTF911');
  }
  const currentCall = useSelector(
    state => state.emergencyCalls.callQueue[callerID],
  );
  const mostRecentLocations = getMostRecentLocations(currentCall);
  const primaryLocation = mostRecentLocations.mostRecentLocation;
  const secondaryLocation = mostRecentLocations.mostRecentSecondaryLocation;

  const isConsideredLandline =
    isSourceAniAli(primaryLocation) || isSourceAniAli(secondaryLocation);

  return !isConsideredLandline;
};

export default useShouldRenderTF911;
